import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';

/**
 * Kontrola, že je zadán rok zrání, pokud jde o semenný RM.
**/
@Injectable({
  providedIn: 'root'
})
export class RokZraniRequiredValidator implements Validator {

  private semennyRm: number = 1;

  validate(control: AbstractControl): ValidationErrors | null {
    let druhRm = control.parent?.get('druhRepMaterialu')?.value;
    if (druhRm?.kod == this.semennyRm && (control.value == void 0 || control.value == '')) {
      return { 'rokZraniRequired': 'Pro semenný RM je rok zrání povinný.' };
    }
    return null;
  }
}
